import { render, staticRenderFns } from "./fromEntity.vue?vue&type=template&id=0b97971d&scoped=true&"
import script from "./fromEntity.vue?vue&type=script&lang=js&"
export * from "./fromEntity.vue?vue&type=script&lang=js&"
import style0 from "./fromEntity.vue?vue&type=style&index=0&id=0b97971d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b97971d",
  null
  
)

export default component.exports